import { render, staticRenderFns } from "./CoverView.vue?vue&type=template&id=f8c806d4&"
import script from "./CoverView.vue?vue&type=script&lang=js&"
export * from "./CoverView.vue?vue&type=script&lang=js&"
import style0 from "./CoverView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f8c806d4')) {
      api.createRecord('f8c806d4', component.options)
    } else {
      api.reload('f8c806d4', component.options)
    }
    module.hot.accept("./CoverView.vue?vue&type=template&id=f8c806d4&", function () {
      api.rerender('f8c806d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/generic/CoverView.vue"
export default component.exports